import { render } from "./SidebarItem.vue?vue&type=template&id=186720a8"
import script from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Helpers/SidebarItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "186720a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('186720a8', __exports__)) {
    api.reload('186720a8', __exports__)
  }
  
  module.hot.accept("./SidebarItem.vue?vue&type=template&id=186720a8", () => {
    api.rerender('186720a8', render)
  })

}


export default __exports__